import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { ExternalGuestAttendeeStatsPoint } from '../../../../types/dashboard';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type ExternalGuestAttendeesReportListProps = {
    points: ExternalGuestAttendeeStatsPoint[];
};

type SummaryRow = ExternalGuestAttendeeStatsPoint & { id: number };

export default function ExternalGuestAttendeesReportList({
    points,
}: ExternalGuestAttendeesReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: 'Period',
                size: 180,
            },
            {
                accessorKey: 'attendeeCount',
                header: 'External Guest Attendees',
                size: 180,
            },
        ],
        [],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No external guest attendees found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='External Guest Attendees Summary'
            />
        </Box>
    );
}
